import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const newsletterProviderEntity: Entity = {
  model: model,
  repository: repository,
}

export default newsletterProviderEntity
